// src/app/components/foundation/PageContainer.tsx
import type { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export interface PageContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}

/**
 * Marks a feature page's root element. Presentation-only: renders a
 * single div with a stable `vania-page-container` hook class and passes
 * every other className/prop through untouched. Identical contract to
 * representative-admin's PageContainer.
 */
export function PageContainer({ children, className, ...rest }: PageContainerProps) {
  return (
    <div className={clsx('vania-page-container', className)} {...rest}>
      {children}
    </div>
  );
}
